import { Layout, Text, Button } from '@loadsmart/miranda-react'
import { toSpacingCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { RequestStatus } from 'core/domain/Request'

import { hasAttachments, type Load } from '../domain/Load'

export type LoadAttachmentListProps = {
  readonly load: Load
  readonly onAttachmentDownload: (attachmentId: number) => void
  readonly statusAttachment?: RequestStatus
}

export function LoadAttachmentList({
  load,
  onAttachmentDownload,
  statusAttachment,
}: LoadAttachmentListProps) {
  if (!hasAttachments(load)) {
    return null
  }

  const isLoading = statusAttachment === RequestStatus.Pending

  return (
    <Layout.Box
      padding="spacing-6"
      backgroundColor="color-background-primary"
      borderRadius="border-radius-s"
      borderWidth="border-thin"
      borderColor="color-border"
    >
      <Layout.Stack gap="spacing-3">
        <Text variant="heading-sm-bold">Attachments</Text>
        <Layout.Stack gap="spacing-2">
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: toSpacingCSSValue('spacing-2'),
            }}
          >
            {load.attachments!.map(attachment => (
              <li key={attachment.id}>
                <Layout.Box
                  padding="spacing-4"
                  borderRadius="border-radius-s"
                  borderWidth="border-thin"
                  borderColor="color-border"
                >
                  <Layout.Group justify="space-between" align="center">
                    <Text variant="body-md">{attachment.fileName}</Text>
                    <Button
                      variant="tertiary"
                      onClick={() => onAttachmentDownload(attachment.id)}
                      disabled={isLoading}
                      loading={isLoading}
                    >
                      View
                    </Button>
                  </Layout.Group>
                </Layout.Box>
              </li>
            ))}
          </ul>
        </Layout.Stack>
      </Layout.Stack>
    </Layout.Box>
  )
}
